/** Matches $w-max-tablet. Desktop anchor starts at $w-min-desktop-s (1025px). */
export const PRICE_MODAL_CENTER_MQ = '(max-width: 1024px)';

export const priceModalUsesCenter = () => window.matchMedia(PRICE_MODAL_CENTER_MQ).matches;

/** Drop the desktop anchor (overlay padding, inline width / max-height / margin-top). */
export const clearAnchoredPriceModal = (overlay) => {
  if (!overlay) return;
  overlay.style.padding = '';
  const modal = overlay.querySelector('.hp-modal');
  if (!(modal instanceof HTMLElement)) return;
  modal.style.width = '';
  modal.style.maxHeight = '';
  modal.style.marginTop = '';
};
